import { useQuery, useMutation } from "react-query";
import { addMood, getMoods, updateMood } from "../services/moods";

export const useGetMoods = (payload) =>
	useQuery(["getMoods", payload], () => getMoods(payload));

export const useAddMood = () =>
	useMutation("addMood", (payload) => addMood(payload));

export const useUpdateMood = () =>
	useMutation("updateMood", (payload) => updateMood(payload));
